import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState, getGlobalState } = createGlobalState({
	mouseMoving: true
});

export { setGlobalState, useGlobalState, getGlobalState };
